import { template } from 'lodash';

const generateMessage = (
  msgTemplate: string,
  params?: Record<string, string | number>,
): string =>
  template(msgTemplate, {
    interpolate: /\${([\s\S]+?)}/g,
  })(params);

export { generateMessage };
